const audienceList = () => import('@/pages/AudienceSet/AudienceList.vue');
const audienceId = () => import('@/pages/AudienceSet/_AudienceId.vue');
const tagList = () => import('@/pages/TagSet/TagList.vue');
const tagId = () => import('@/pages/TagSet/_TagId.vue');
const filterTagStep = () => import('@/pages/FilterTag/FilterTagStep.vue');

export default {
  name: 'audienceManagement',
  meta: {
    key: 'audienceManagement'
  },
  path: '/audience-management',
  children: [
    {
      name: 'audienceManagementList',
      icon: 'ic_common_tag',
      path: '/audience-management/audience-list',
      meta: {
        permission: ['filtration']
      },
      component: audienceList
    },
    {
      name: 'audienceManagementId',
      path: '/audience-management/audience-list/:id',
      meta: {
        hidden: true,
        permission: ['filtration']
      },
      component: audienceId
    },
    {
      name: 'tagManagement',
      icon: 'ic_common_tag_management',
      path: '/audience-management/tag-management/list',
      meta: {
        permission: ['tag']
      },
      component: tagList
    },
    {
      name: 'tagManagementId',
      path: '/audience-management/tag-management/:id',
      meta: {
        hidden: true,
        permission: ['tag']
      },
      component: tagId
    },
    {
      name: 'screeningLabeling',
      icon: 'ic_common_filter_tag',
      path: '/audience-management/filter-labeling',
      meta: {
        permission: ['tag', 'filtration']
      },
      component: filterTagStep
    }
  ]
};
